import { FaFacebook } from "react-icons/fa";
import { FaTwitterSquare } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaMapMarkerAlt } from "react-icons/fa";
import { IoMdTime } from "react-icons/io";

const HomeContent = [
  {
    title: " based on the AI technology",
    homeDesc:
      "Powerful natural language processing capabilities, that can understand and respond to customer inquiries in real-time & improve customer satisfaction.",
    btnTex1: "Get started Free",
    Text2: "Book a Demo",
    imgdesc1: "15 min discovery call",
    imgdesc2: "Talk with a specialist",
    homeImg: "/assert/img1.png",
    userProfile: "/assert/img2.png",
    backgroundImage: "/assert/homeBG.pgn",
  },
];

export { HomeContent };

const DemoData = [
  {
    title: "Better user satisfaction",
    desc: "Our customer support AI tool is an advanced software solution that helps businesses provide efficient and personalized support to their customers.",
    clip: "/assert/clip.mp4",
    logo1: "/assert/Snowflake.png",
    logo3: "assert/InvertDark.svg",
    logo5: "assert/HitechDark.svg",
  },
];
export { DemoData };

const IntegrateData = [
  {
    IntegrateIcon: "/assert/icon1.png",
    IntegrateTittle: "Registration",
    IntegrateDesc: "Create your company account to start using all features",
  },
  {
    IntegrateIcon: "/assert/icon2.png",
    IntegrateTittle: "Set up the AI",
    IntegrateDesc: "Choose your branding colors, tone of voice and more.",
  },
  {
    IntegrateIcon: "/assert/icon3.png",
    IntegrateTittle: "Publish the AI bot",
    IntegrateDesc: "Start using the bot on your website with line of code",
  },
];
export { IntegrateData };

const MinimizeData = [
  {
    desc1: "Efficient workflows and custom white label solution",
    desc2: "Simple installation without development skills",
    desc3: "Third party integrations with different SaaS tools",
    image: "/assert/img3.png",
  },
];

export { MinimizeData };

const BusinessData = [
  {
    desc1: "Efficient workflows and custom white label solution",
    desc2: "Simple installation without development skills",
    desc3: "Third party integrations with different SaaS tools",
    image: "/assert/img4.png",
  },
];
export { BusinessData };

const ClientData = [
  {
    desc1: "Efficient workflows and custom white label solution",
    desc2: "Simple installation without development skills",
    desc3: "Third party integrations with different SaaS tools",
    image: "/assert/img5.png",
  },
];

export { ClientData };

const CardData = [
  {
    cardimg: "/assert/card1.jpeg",
    title: "5 Great Web Design Resources",
    type: "Analytics",
    desc: "Est placeat perspicia",
    img: "/assert/author1_anna.png",
    authorName: "Anna Oneal",
    date: "March 28, 2023",
    realTime: "3 min read",
  },
  {
    cardimg: "/assert/card2.jpeg",
    title: "What Will Website Be Like In 100 Years?",
    type: "Marketing",
    desc: "Dolorem laborum vero laudantium perspiciatis iste ",
    img: "/assert/author3.png",
    authorName: "Carla Rosa",
    date: "March 28, 2023",
    realTime: "2 min read",
  },
  {
    cardimg: "/assert/card1.jpeg",
    title: "10 Great Examples of Responsive Websites",
    type: "Business",
    desc: "Et odit soluta sint temporibus quia dolorem aut unde est. Voluptatibus molestiae vitae iste et adipisci ex saepe veritatis. Quam excepturi ",
    img: "/assert/author2.png",
    authorName: "MIke Dean",
    date: "March 28, 2023",
    realTime: "2 min read",
  },
  {
    cardimg: "/assert/card4.jpeg",
    title: "5 Principles Of Effective Web Design",
    type: "Business",
    desc: "Sapiente amet molestias cum fugiat qui aspernatur.",
    img: "/assert/author3.png",
    authorName: "MIke Dean",
    date: "March 28, 2023",
    realTime: "3 min read",
  },
  {
    cardimg: "/assert/card5.jpeg",
    title: "20 Myths About Web Design Processes",
    type: "Analytics",
    desc: "Perferendis qui qui nihil ut numquam consequatur. Commodi sit quia eligendi. Aut maiores voluptates est.",
    img: "/assert/author3.png",
    authorName: "Carla Rosa",
    date: "March 28, 2023",
    realTime: "5 min read",
  },
  {
    cardimg: "/assert/card6.jpeg",
    title: "7 Must Have Tools For Web Designers & Developers",
    type: "Resources",
    desc: "Enim exercitationem sunt fuga molestiae. Assumenda sit quis impedit. Autem optio ad et sed. Dolor voluptates ea quis fuga adipisci commod",
    img: "/assert/author1_anna.png",
    authorName: "Anna Oneal",
    date: "March 28, 2023",
    realTime: "4 min read",
  },
];
export { CardData };

const SupportData = [
  {
    tittle: "Ready to save more on the customer support side?",
    desc: "Automate routine tasks and provide fast, accurate responses & reduce the need for human staff and improve overall efficiency.",
    btnDesc: "Let's get started",
  },
];
export { SupportData };

const ProductData = [
  {
    productIMg: "/assert/product-img.png",
  },
];

export { ProductData };

const footerData = [
  {
    address: "Address:",
    desc: "2774 Oak Drive, Plattsburgh, New York",
    contact: "Contact:",
    phone: "518-564-3200",
    email: "contact@startAI.com",
  },
  ["About us", "Book a demo", "Blog", "Pricing", "Contact"],
  ["Features", "Sign In", "Sign Up", "Forgot Password"],

  ["Style Guide", "Changelog", "Licenses"],
];
export { footerData };

const fqaData = [
  {
    question: "Is there a free tier?",
    answer:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quasi dolores optio architecto, tempore aliquam beatae aut aliquid? Voluptatibus, corporis numquam molestiae quidem ex sunt suscipit tempore nulla sed officia incidunt sequi. Corrupti ducimus voluptas consectetur iure alias nostrum dolorum temporibus.",
  },
  {
    question: "How much does it cost if I need more?",
    answer:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quasi dolores optio architecto, tempore aliquam beatae aut aliquid? Voluptatibus, corporis numquam molestiae quidem ex sunt suscipit tempore nulla sed officia incidunt sequi. Corrupti ducimus voluptas consectetur iure alias nostrum dolorum temporibus.",
  },
  {
    question: "Is Hyre also available for Enterprise?",
    answer:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quasi dolores optio architecto, tempore aliquam beatae aut aliquid? Voluptatibus, corporis numquam molestiae quidem ex sunt suscipit tempore nulla sed officia incidunt sequi. Corrupti ducimus voluptas consectetur iure alias nostrum dolorum temporibus.",
  },
  {
    question: "What does success look like for StartAI?",
    answer:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quasi dolores optio architecto, tempore aliquam beatae aut aliquid? Voluptatibus, corporis numquam molestiae quidem ex sunt suscipit tempore nulla sed officia incidunt sequi. Corrupti ducimus voluptas consectetur iure alias nostrum dolorum temporibus.",
  },
  {
    question: "How many active users are available in the free plan?",
    answer:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quasi dolores optio architecto, tempore aliquam beatae aut aliquid? Voluptatibus, corporis numquam molestiae quidem ex sunt suscipit tempore nulla sed officia incidunt sequi. Corrupti ducimus voluptas consectetur iure alias nostrum dolorum temporibus.",
  },
  {
    question: "Who is StartAI tool designed for?",
    answer:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quasi dolores optio architecto, tempore aliquam beatae aut aliquid? Voluptatibus, corporis numquam molestiae quidem ex sunt suscipit tempore nulla sed officia incidunt sequi. Corrupti ducimus voluptas consectetur iure alias nostrum dolorum temporibus.",
  },
  {
    question: "How can I get a custom plan?",
    answer:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quasi dolores optio architecto, tempore aliquam beatae aut aliquid? Voluptatibus, corporis numquam molestiae quidem ex sunt suscipit tempore nulla sed officia incidunt sequi. Corrupti ducimus voluptas consectetur iure alias nostrum dolorum temporibus.",
  },
];
export { fqaData };

const PricingData = [
  {
    img: "/assert/perfect-basic.png",
    title: "Basic",
    monthlyPrice: "Free",
    yearlyPrice: "Free",
    btn: "Get started free",
    desc: "Free plan for all users.",
    lists: [
      "2 Workspaces",
      "10 Collaboration",
      "unlimited tickets",
      "unified Analytics",
    ],
  },
  {
    img: "/assert/perfect-efficient.png",
    title: "Efficient",
    monthlyPrice: "$25/month",
    yearlyPrice: "$15/month",
    btn: "Get efficient plan",
    desc: "Ideal for small businesses..",
    lists: [
      "Unlimited Workspace",
      "unlimited colaboration",
      "15 GBdata storage",
      "unified Analytics",
      "Mobile apll acces",
    ],
  },
  {
    img: "/assert/perfect-team.png",
    title: "Team",
    monthlyPrice: "$39/month",
    yearlyPrice: "$29/month",
    btn: "Get team plan",
    desc: "Works best for enterprise companies.",
    lists: [
      "Unlimited Workspace",
      "unlimited colaboration",
      "Unlimited GBdata storage",
      "Time tracking module",
      "Unified Analytics",
      "HR & Payroll",
    ],
  },
];
export { PricingData };

const TeamMemberCardDetails = [
  {
    img: "/assert/img_1.png",
    name: "James Wilson",
    proffesional: "Product Designer",
    facebook: <FaFacebook />,
    twitter: <FaTwitterSquare />,
    instagram: <FaInstagram />,
  },
  {
    img: "/assert/img_2.png",
    name: "James Wilson",
    proffesional: "Product Designer",
    facebook: <FaFacebook />,
    twitter: <FaTwitterSquare />,
    instagram: <FaInstagram />,
  },
  {
    img: "/assert/img_3.png",
    name: "James Wilson",
    proffesional: "Product Designer",
    facebook: <FaFacebook />,
    twitter: <FaTwitterSquare />,
    instagram: <FaInstagram />,
  },
  {
    img: "/assert/img_4.png",
    name: "James Wilson",
    proffesional: "Product Designer",
    facebook: <FaFacebook />,
    twitter: <FaTwitterSquare />,
    instagram: <FaInstagram />,
  },
  {
    img: "/assert/img_1.png",
    name: "James Wilson",
    proffesional: "Product Designer",
    facebook: <FaFacebook />,
    twitter: <FaTwitterSquare />,
    instagram: <FaInstagram />,
  },
  {
    img: "/assert/img_2.png",
    name: "James Wilson",
    proffesional: "Product Designer",
    facebook: <FaFacebook />,
    twitter: <FaTwitterSquare />,
    instagram: <FaInstagram />,
  },
  {
    img: "/assert/img_3.png",
    name: "James Wilson",
    proffesional: "Product Designer",
    facebook: <FaFacebook />,
    twitter: <FaTwitterSquare />,
    instagram: <FaInstagram />,
  },
  {
    img: "/assert/img_4.png",
    name: "James Wilson",
    proffesional: "Product Designer",
    facebook: <FaFacebook />,
    twitter: <FaTwitterSquare />,
    instagram: <FaInstagram />,
  },
];
export { TeamMemberCardDetails };

const currentlyData = [
  {
    title: "Product Designer",
    locationIcon: <FaMapMarkerAlt />,
    locaton: "san Francisco, CA",
    timeIcon: <IoMdTime />,
    time: "Full time",
  },
  {
    title: "Marketing Growth",
    locationIcon: <FaMapMarkerAlt />,
    locaton: "Ontario, Canada",
    timeIcon: <IoMdTime />,
    time: "Part Time",
  },
  {
    title: "DevOps Engineer",
    locationIcon: <FaMapMarkerAlt />,
    locaton: "Miami, Florida",
    timeIcon: <IoMdTime />,
    time: "Full time",
  },
  {
    title: "UX/UI Designer",
    locationIcon: <FaMapMarkerAlt />,
    locaton: "san Francisco, CA",
    timeIcon: <IoMdTime />,
    time: "Full time",
  },
];
export { currentlyData };

const BetterPeoductData = [
  {
    amount: "467",
    description: "Stutups job",
  },
  {
    amount: "6254",
    description: "Tickets resolved",
  },
  {
    amount: "32",
    description: "Industries covered",
  },
  {
    amount: "$1.2M",
    description: "Saved on jobs",
  },
];
export { BetterPeoductData };

const contactData = [
  {
    img: "/assert/Email.svg",
    title: "Email",
    desc: "office@gmail.com",
  },
  {
    img: "/assert/call.svg",
    title: "Phone support",
    desc: "+1 3370 009 000",
  },
  {
    img: "/assert/Location.svg",
    title: "Our location",
    desc: "Blue Orchid Tower, Bucharest, Romania",
  },
];
export { contactData };
